/* eslint-disable react/prop-types */
import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Styles from "./ToggleStructure.styles";
import { selectAllSIUsers } from "../../../redux/selectors/user";

export default function ToggleStructure({ value, handleChange }) {
  const { isDistrictSi, isDistrictLeader } = useSelector(selectAllSIUsers);
  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value || ""}
        onChange={handleChange}
      >
        <FormControlLabel
          value="assignedToMe"
          control={<Radio size="small" />}
          label={
            <Typography style={Styles.typographyRadio}>
              To the structure
            </Typography>
          }
        />
        <FormControlLabel
          value="initiated"
          control={<Radio size="small" />}
          label={
            <Typography style={Styles.typographyRadio}>
              Out of the structure
            </Typography>
          }
        />
        {!isDistrictSi && !isDistrictLeader && (
          <FormControlLabel
            value="belowStructure"
            control={<Radio size="small" />}
            label={
              <Typography style={Styles.typographyRadio}>
                Below the structure
              </Typography>
            }
          />
        )}
      </RadioGroup>
    </FormControl>
  );
}
